import React, { Component } from "react";
import { connect } from "react-redux";
import Menu from "Menu";
// import Footer from "./Footer/Footer";
import { NotificationContainer } from "react-notifications";
import SubMenu from "../Menu/SubMenu/SubMenu";
import { HORIZONTAL } from "Config";
import { selectCurrentNavPage, selectLoggedAs } from "Selectors";
import Footer from "./Footer/Footer";

export class Layout extends Component {
  componentDidMount() {
    $(document).foundation();
  }

  render() {
    const {
      subMenuDirection,
      loggedAs,
      withoutHeader,
      notConnectedAccess,
      user
    } = this.props;

    if (withoutHeader) {
      return (
        <div className="off-canvas-wrapper">
          <div className="off-canvas-content">
            <div
              className={`flex-container flex-child-auto ${
                subMenuDirection === HORIZONTAL
                  ? "flex-dir-column"
                  : "flex-dir-row"
              }`}
            >
              <SubMenu
                withoutHeader={withoutHeader}
                user={user}
                loggedAs={loggedAs}
              />
              <div className="flex-child-auto flex-container flex-dir-column">
                {this.props.children}
                {loggedAs === "GUEST" ? <Footer /> : null}
              </div>
            </div>
          </div>
          <div className="mask hide" />
        </div>
      );
    }

    return (
      <div className="off-canvas-wrapper">
        <div className="off-canvas-content">
          <Menu notConnectedAccess={notConnectedAccess} />
          <NotificationContainer />
          <div
            className={`flex-container flex-child-auto ${
              subMenuDirection === HORIZONTAL
                ? "flex-dir-column"
                : "flex-dir-row"
            }`}
          >
            <SubMenu user={user} loggedAs={loggedAs} />
            <div className="flex-child-auto flex-container flex-dir-column">
              {this.props.children}
              {loggedAs === "GUEST" ? <Footer /> : null}
            </div>
          </div>
        </div>
        <div className="mask hide" />
      </div>
    );
  }
}

// Connected Component
const mapStateToProps = state => ({
  subMenuDirection: state.params.subMenuDirection,
  currentNavPage: selectCurrentNavPage(state),
  loggedAs: selectLoggedAs(state),
  user: state.auth.user
});

export default connect(mapStateToProps)(Layout);



// WEBPACK FOOTER //
// ./src/components/Layout/Layout.js